module.exports = require('./lib/linkify-html').default;



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/html.js
// module id = 83
// module chunks = 0 1